import { Skeleton } from '@/components/ui/skeleton';

export default function RenderSkeleton({
  count = 3,
  className = 'h-10 w-full',
}: {
  count?: number;
  className?: string;
}) {
  return (
    <div className='space-y-4'>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className={className} />
      ))}
    </div>
  );
}
